// Import dependencies
import gsap from 'gsap';
import { q1O } from '../util/nE';
import state from '../state';

/**
 * ModalLinks class
 * Handles opening of modal links based on URL parameters.
 */
class ModalLinks {
  constructor() {
    // Select all <a> elements containing "?modal=" in the href attribute.
    this.openTriggers = document.querySelectorAll('a[href*="?modal="]');
    // Initialize modals based on a generic 'modal' tag.
    // Actual selection will be updated in openModal before use.
    this.modals = document.querySelectorAll('modal');
  }

  /**
   * Opens the modal corresponding to the URL parameter "modal".
   * @param {Event} event - The event triggered by clicking a modal link.
   */
  openModal(event) {
    // Update modals selection to elements with the .modal class.
    this.modals = document.querySelectorAll('.modal');

    // Prevent default link behavior.
    event.preventDefault();

    // Get URL parameters from event target or window location.
    const pageModal = document.querySelector('[data-page-modal]')
      ? document.querySelector('[data-page-modal]').dataset.pageModal
      : false;
    const $ahref = event && event.target && event.target.closest('a');

    const urlParams = new URLSearchParams(
      $ahref && $ahref.search ? $ahref.search : window.location.search
    );

    // Retrieve the modal ID from the URL parameters.
    const modalId = pageModal ? pageModal : urlParams.get('modal');
    // Find the modal element with a data-modal-id attribute matching modalId.

    const $modal = Array.from(this.modals).find(
      el => el.getAttribute('data-modal-id') === modalId
    );

    // Animate the modal to appear using gsap.
    gsap.to($modal, {
      autoAlpha: 1, // Fade in the element.
      duration: 0.6,
      ease: t => q1O(t), // Use custom easing function.
      onStart: () => {
        // After animation, update the URL with the modal parameter.
         //  const url = new URL(window.location);
         //  url.searchParams.set('modal', modalId);
        //   window.history.pushState({}, '', url);
      },
    });

    // If a custom cursor handler exists, hide the cursor.
    if (state.cursor) {
      state.cursor.onCursorHide();
    }

    // If a smooth scrolling instance exists, stop it.
    if (state.smoothScroll) {
      state.smoothScroll.lenis.stop();
    }
  }

  /**
   * Initializes modal link triggers.
   * Automatically opens modal if URL contains "modal" parameter.
   * Attaches click event listeners to modal trigger links.
   */
  init() {
    // Automatically open modal if URL contains the "modal" parameter.
    if (
      new URLSearchParams(window.location.search).has('modal') ||
      window.location.pathname.includes('/contact')
    ) {
      // Call openModal with a dummy event object.
      this.openModal({ preventDefault: () => {} });
    }

    // Attach click event listeners to all modal trigger links.
    this.openTriggers.forEach(trigger => {
      trigger.addEventListener('click', this.openModal.bind(this));
    });
  }

  /**
   * Cleans up event listeners attached by init().
   */
  destroy() {
    // Remove click event listeners from the modal trigger links.
    this.openTriggers.forEach(trigger => {
      trigger.removeEventListener('click', this.openModal.bind(this));
    });
  }
}

export default ModalLinks;



//////////////////
// WEBPACK FOOTER
// ./scripts/util/ModalLinks.js
// module id = 17
// module chunks = 0